(function () {
  function initFreeShippingBar() {
    var bar = document.getElementById('free-shipping-bar');
    if (!bar) return;

    var minimo = parseFloat(bar.dataset.thresholdMinimo);
    var thresholds = {
      piccoli: [
        parseFloat(bar.dataset.thresholdPiccoli1),
        parseFloat(bar.dataset.thresholdPiccoli2)
      ],
      medi: [
        parseFloat(bar.dataset.thresholdMedi1),
        parseFloat(bar.dataset.thresholdMedi2)
      ]
    };
    var categoryLabels = {
      piccoli: bar.dataset.categoryLabelPiccoli || '',
      medi: bar.dataset.categoryLabelMedi || ''
    };
    var currency = bar.dataset.currency || '\u20ac';
    var fill = bar.querySelector('.free-shipping-bar__fill');
    var cp0 = bar.querySelector('.free-shipping-bar__checkpoint--0');
    var cp1 = bar.querySelector('.free-shipping-bar__checkpoint--1');
    var cp2 = bar.querySelector('.free-shipping-bar__checkpoint--2');
    var message = bar.querySelector('.free-shipping-bar__message');
    var categoryEl = bar.querySelector('.free-shipping-bar__category');
    var threshold0Label = cp0.querySelector('.free-shipping-bar__threshold-label');
    var threshold1Label = cp1.querySelector('.free-shipping-bar__threshold-label');
    var threshold2Label = cp2.querySelector('.free-shipping-bar__threshold-label');
    var icon0 = cp0.querySelector('.free-shipping-bar__checkpoint-icon');

    function formatMoney(amount) {
      return currency + amount.toFixed(2).replace('.', ',');
    }

    function formatThreshold(amount) {
      var value = Number.isInteger(amount) ? amount : amount.toFixed(2).replace('.', ',');
      return value + currency;
    }

    function update(cart) {
      var hasMedio = cart.items.some(function (item) {
        return item.product_type === 'medi';
      });
      var category = hasMedio ? 'medi' : 'piccoli';
      var soglia1 = thresholds[category][0];
      var soglia2 = thresholds[category][1];
      var subtotal = cart.total_price / 100;

      var pct0 = (minimo / soglia2) * 100;
      var pct1 = (soglia1 / soglia2) * 100;
      var pctFill = Math.min(100, (subtotal / soglia2) * 100);

      fill.style.width = pctFill + '%';
      cp0.style.left = pct0 + '%';
      cp1.style.left = pct1 + '%';

      categoryEl.textContent = categoryLabels[category];
      threshold0Label.textContent = formatThreshold(minimo);
      threshold1Label.textContent = formatThreshold(soglia1);
      threshold2Label.textContent = formatThreshold(soglia2);

      bar.classList.remove('free-shipping-bar--below-minimum', 'free-shipping-bar--complete');

      if (subtotal < minimo) {
        icon0.textContent = '\uD83D\uDD12';
        bar.classList.add('free-shipping-bar--below-minimum');
        var mancanoMinimo = minimo - subtotal;
        message.textContent =
          'Ordine minimo ' + formatThreshold(minimo) + ' \u2014 ti mancano ' +
          formatMoney(mancanoMinimo) + ' per attivarlo';
      } else {
        icon0.textContent = '\u2705';
        if (subtotal >= soglia2) {
          message.textContent = 'Spedizione a domicilio gratuita sbloccata! \uD83C\uDF89';
          bar.classList.add('free-shipping-bar--complete');
        } else if (subtotal >= soglia1) {
          var mancanoDomicilio = soglia2 - subtotal;
          message.textContent =
            'Locker InPost gratuito \u2713 \u2014 ti mancano ' + formatMoney(mancanoDomicilio) +
            ' per la spedizione a domicilio gratuita';
        } else {
          var mancanoLocker = soglia1 - subtotal;
          message.textContent =
            'Ti mancano ' + formatMoney(mancanoLocker) +
            ' per la spedizione con Locker InPost gratuita';
        }
      }
    }

    function refresh() {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(update)
        .catch(function (err) { console.error('free-shipping-bar:', err); });
    }

    refresh();

    document.addEventListener('cart:update', refresh);
  }

  document.addEventListener('DOMContentLoaded', initFreeShippingBar);
})();
